import { Box, Row, Txt } from "@stenajs-webui/core";
import { Label, PrimaryButton, SecondaryButton } from "@stenajs-webui/elements";
import { Checkbox, TextInput } from "@stenajs-webui/forms";
import { Window, WindowFooter } from "@stenajs-webui/modal";
import { useEffect, useState } from "react";
import { GapValues } from "@/lib/utils/GapValues";
import { RebateProgress } from "@/gql/graphql";

export const ExpectedVolumeForm = ({
  isOpen,
  rebate,
  onDone,
  onSave,
  loading,
}: {
  isOpen: boolean;
  rebate?: RebateProgress;
  onDone: () => void;
  onSave: (goalId: string, expectedVolume: number) => void;
  loading: boolean;
}) => {
  const [editedValue, setEditedValue] = useState<string>();
  const [useSuggested, setUseSuggested] = useState<boolean>(false);

  const useSuggestedChanged = (value: boolean) => {
    setEditedValue(
      (value
        ? rebate?.suggestedExpectedVolume
        : rebate?.expectedVolume
      )?.toString() ?? ""
    );
    setUseSuggested(value);
  };

  const save = () => {
    if (rebate && editedValue) {
      const goalId = rebate.goalId;
      const expectedVolume = Number.parseInt(editedValue);
      if (goalId && expectedVolume) {
        onSave(goalId, expectedVolume);
      }
    }
  };

  useEffect(() => {
    if (rebate) {
      setEditedValue(rebate?.expectedVolume?.toString() ?? "");
    }
  }, [rebate]);

  const saveDisabled =
    loading ||
    editedValue?.length === 0 ||
    rebate?.expectedVolume?.toString() === editedValue;

  return (
    <Window
      isOpen={isOpen}
      onRequestClose={onDone}
      headerText="Change Expected Volume"
      indent={GapValues.TWENTYFOUR}
    >
      <Box gap={GapValues.TWENTYEIGHT}>
        <Row gap={GapValues.TWENTYFOUR}>
          <Label text="Agreement">
            <Txt>
              {`${rebate?.rebateAgreement?.rebateAgreementNumber} ${rebate?.rebateAgreement?.name}`}
            </Txt>
          </Label>
          <Label text="Current Expected volume">
            <Txt>{rebate?.expectedVolume}</Txt>
          </Label>
          <Label text="Suggested Expected volume">
            <Txt>{rebate?.suggestedExpectedVolume}</Txt>
          </Label>
        </Row>

        <Row gap={GapValues.TWENTYFOUR}>
          <Label text="New Expected volume">
            <TextInput
              value={editedValue}
              onValueChange={setEditedValue}
              disabled={useSuggested}
            />
          </Label>
          <Label text="Use Suggested">
            <Checkbox
              value={useSuggested}
              onValueChange={useSuggestedChanged}
            />
          </Label>
        </Row>
      </Box>
      <WindowFooter>
        <Row gap={GapValues.SIXTEEN} justifyContent="flex-end">
          <SecondaryButton label="Close" onClick={() => onDone()} />
          <PrimaryButton
            label="Save"
            disabled={saveDisabled}
            onClick={() => save()}
            loading={loading}
          />
        </Row>
      </WindowFooter>
    </Window>
  );
};
